import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
//import { CadenasService } from 'src/app/aplicaciones-modulos/presupuesto-sellout/services/cadenas.service';
//import { CatalogoCadenasService } from 'src/app/aplicaciones-modulos/presupuesto-sellout/services/catalogo-cadenas.service';
import { CommonFormService } from 'src/app/shared/utils/common-form.service';
import {
  LfsaBotonEditarGridComponent
} from 'src/app/shared/components/lfsa-boton-editar-grid/lfsa-boton-editar-grid.component';
import { UtilsService } from 'src/app/shared/utils/utils.service';
import { indicadoresVivosModulo } from '../../diccionarios/indicadoresVivosModulo';
import { IndicadoresVivosVModel, IndicadoresVivosVModelInterface } from '../../models/indicadoresVivosVModel';
import { CatalogoIndicadoresService } from '../../services/catalogo-indicadores.service';
import { DireccionesService } from '../../services/direcciones.service';
import { IndicadoresVivosService } from '../../services/indicadores-vivos.service';
import { VersionesService } from '../../services/versiones.service';

@Component({
  selector: 'app-mantenedor-facturas-marcas',
  templateUrl: './mantenedor-facturas-marcas.component.html',
  styleUrls: ['./mantenedor-facturas-marcas.component.css']
})
export class MantenedorFacturasMarcasComponent implements OnInit {

  tituloCard: string = 'Mantenedor Facturas y Marcas';
  tituloForm: string = 'Listado De Facturas y Marcas';

  buscador: FormGroup;
  formulario: FormGroup;

  mostrarFormulario: boolean = false;
  editableForm: boolean = false;

  cmbPeriodo: { clave: number; valor: string; }[];

  rowData: any[] = [];
  frameworkComponents: any;
  gridApi: any;
  gridColumnApi: any;
  columnDefs: any[];
  rowSelection: any;
  textoBuscar: string;

  private STATUS_UPDATE: string = "420";

  //componentes para apuntar a diccionario
  DAT_BTNS;
  DAT_MSG;
  DAT_BTNCSS;

  textBoton: string;

  //para cargar con el grid
  listaVacia: boolean = true;
  loading: boolean = false;
  modulo: any = {};
  GUARDAR: string = 'guardar';

  cmbEstados: any[] = [
    {
      clave: 'A',
      valor: 'A'
    },
    {
      clave: 'C',
      valor: 'C'
    },
  ];

  constructor(
    private fb: FormBuilder,
    private commonFormService: CommonFormService,
    private _utils: UtilsService,
    private _indicadores: IndicadoresVivosService,
    private _versiones: VersionesService,
    private _catalogo: CatalogoIndicadoresService,
  ) { }

  ngOnInit() {
    this.modulo = indicadoresVivosModulo;
    this.DAT_BTNS = this.modulo.button.buttonsNombre;
    this.DAT_MSG = this.modulo.mensajes;
    this.DAT_BTNCSS = this.modulo.button.buttonsCss;

    this.buscador = this.fb.group({
      anio: ['', [Validators.required]],
      desde: ['', [Validators.required]],
      hasta: ['', [Validators.required]],
      agencia: ['', [Validators.required]],
      version: ['', [Validators.required]],
    });

    this.formulario = this.fb.group({
      fecha_registro: ['', []],
      usuario: ['', []],
      anio: ['', []],
      mes: ['', []],
      mesDescripcion: ['', []],
      fechaHoraSys: ['', null],
      codigoVendedor: ['', []],
      nombreVendedor: ['', []],
      version: ['', []],
      nroMarcas: ['', [Validators.required]],
      nroFacturas: ['', [Validators.required]],
      versionDescripcion: ['', []],
    });

    this.cmbPeriodo = this._catalogo.catalogoMeses();
    this.cargarGridcomponent();
    this.getVersiones();
    this.getAgencias();

  }

  /* FUNCIONES */
  cargarGridcomponent() {
    this.frameworkComponents = {
      buttonRenderer: LfsaBotonEditarGridComponent,
    };
    this.columnDefs = [
      {
        headerName: 'Versión',
        field: 'versionDescripcion',
        filter: true,
        // width: 120,
        // cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: 'Año',
        field: 'anio',
        filter: true,
        // width: 120,
        // cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: 'Mes',
        field: 'mesDescripcion',
        sortable: true,
        // width: 160,
        filter: true,
        // cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: 'Cod. Vendedor',
        field: 'codigoVendedor',
        sortable: true,
        // width: 160,
        filter: true,
        // cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: 'Nomb. Vendedor',
        field: 'nombreVendedor',
        sortable: true,
        // width: 160,
        filter: true,
        // cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: 'No. Marcas',
        field: 'nroMarcas',
        sortable: true,
        // width: 160,
        filter: true,
        // cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: 'No. Facturas',
        field: 'nroFacturas',
        sortable: true,
        // width: 160,
        filter: true,
        // cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: '',
        cellRenderer: 'buttonRenderer',
        width: 150,
        pinned: 'right',
        cellRendererParams: {
          onClick: this.editar.bind(this),
          label: this.DAT_BTNS.editar,
          colorBoton: this.DAT_BTNCSS.warning
        }
      },
      {
        headerName: '',
        cellRenderer: 'buttonRenderer',
        width: 150,
        pinned: 'right',
        cellRendererParams: {
          onClick: this.eliminar.bind(this),
          label: this.DAT_BTNS.eliminar,
          colorBoton: this.DAT_BTNCSS.danger
        }
      },
    ];

    this.rowSelection = 'multiple';
  }

  onQuickFilterChanged() {
    this.gridApi.setQuickFilter(this.textoBuscar);
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;

    params.api.sizeColumnsToFit();

  }

  buscar() {
    this.getIndicadores();
  }

  nuevo() {
    this.formulario.get('id').setValidators(null);
    this.formulario.get('id').updateValueAndValidity();
    this.formulario.get('estado').setValidators(null);
    this.formulario.get('estado').updateValueAndValidity();

    this.commonFormService.abrirFormularioParaGuardar(this);
    this.textBoton = this.DAT_BTNS.guardar;
    this.tituloForm = 'Mantener registro de Presupuesto de Facturas y Marcas';
  }

  editar({ rowData }) {
    let data = rowData;
    data.fecha_registro = '02-02-2023';
    console.log("editar data", data)
    this.formulario.setValue(data);
    document.getElementById('buttonAbrirModal').click();
  }

  acciones(event) {
    // debugger
    if (event === this.GUARDAR) {
      this.guardar();
    } else {
      this.limpiarRegresar();
    }
  }

  limpiarRegresar() {
    this.mostrarFormulario = false;
    this.tituloCard = 'Mantenedor Versiones';
    this.tituloForm = 'Lista De Versiones';
  }

  /** SERVICIOS */
  listaDeVersiones: any = [];

  getVersiones() {
    this.loading = true;
    this._versiones.getVersiones().subscribe((res: any[]) => {
      console.log("getVersiones()", res)
      this.loading = false;
      this.listaDeVersiones = res;

      for (let index = 0; index < this.listaDeVersiones.length; index++)
        this.listaDeVersiones[index].nombre = this.listaDeVersiones[index].id + " - " + this.listaDeVersiones[index].nombre;
    }, (err) => {
      this.loading = false;
      this.listaDeVersiones = [];
    });
  }

  eliminar({ rowData }) {
    this.loading = true;

    rowData.nroMarcas = 20.0;

    this._utils.confirmarSincronoPromesa({
      title: this.DAT_MSG.eliminar,
      text: ``,
      action: this.DAT_BTNS.eliminar,
      funcion: this._indicadores.deleteIndicadoresMarcasFacturas(rowData),
    })
      .then((res: any) => {
        this.gridApi.updateRowData({ remove: this.gridApi.getSelectedRows() });
      })
      .catch((error) => {
        this.loading = false;
      });

  }

  guardar() {
    this._utils.confirmarSincronoPromesaNormal(
      {
        title: this.DAT_MSG.guardar,
        text: '',
        action: this.DAT_BTNS.guardar,
        funcion: this._indicadores.saveIndicadoresMarcasFacturas(this.formulario.value),
        loading: true,
        context: this,
      }
    ).then((res: any) => {
      this.limpiarRegresar();
      this.formulario.reset();
      this.getIndicadores();
    }).catch((err) => {
      if (err.error.key === this.STATUS_UPDATE) {
        this.actualizarRegistroExistente();
      }
    });
  }

  actualizar() {
    this._utils.confirmarSincronoPromesaNormal(
      {
        title: this.DAT_MSG.actualizar,
        text: '',
        action: this.DAT_BTNS.actualizar,
        funcion: this._indicadores.updateIndicadoresMarcasFacturas(this.formulario.value),
        loading: true,
        context: this,
      }
    ).then((res: any) => {
      this.formulario.reset();
      this.getIndicadores();
      document.getElementById('cerrarModal').click();
    }).catch((err) => {
      this._utils.mensajeErroToast(err.error.message, 5000);
    });
  }

  actualizarRegistroExistente() {
    this._utils.confirmarSincronoPromesaNormal(
      {
        title: `El registro ya se encuentra registrado, Desea actualizar nuevamente el registro.`,
        text: '',
        action: this.DAT_BTNS.actualizar,
        funcion: this._indicadores.updateIndicadoresMarcasFacturas(this.formulario.value),
        loading: true,
        context: this,
      }
    ).then((res: any) => {
      this.limpiarRegresar();
      this.formulario.reset();
      this.getIndicadores();
    }).catch((err) => {
      this._utils.mensajeErroToast(err.error.message, 5000);
    });
  }

  downloadDataCsv() {
    let data: any = [];
    let cabecera: any[] = [['Anio', 'Mes', 'Cod.Vendedor', 'Nom.Vendedor', 'Cliente', 'Nom.Cliente', 'Cod.Articulo', 'Articulo', 'Unidades', 'Dolares', 'Kilos']];
    let clonData = this.rowData.map((x) => Object.assign({}, x));
    clonData.forEach((e) => {
      data.push(
        {
          anio: e.anio,
          mesDescripcion: e.mesDescripcion,
          codigoVendedor: e.codigoVendedor,
          nombreVendedor: e.nombreVendedor,
          codigoCliente: e.codigoCliente,
          nombreCliente: e.nombreCliente,
          codigoArticulo: (e.contenedor === undefined) ? `${e.codigoArticulo}` : `${e.codigoArticulo} / ${e.contenedor}`,
          nombreArticulo: e.nombreArticulo,
          unidades: e.unidades,
          dolares: e.dolares,
          kilos: e.kilos
        }
      );
    });
    let name: string = "reporte-mantenedor.csv";
    this._utils.exportCSV(cabecera, data, name);
    this._utils.mensajeOKToast('El archivo csv se exporto correctame.');
  }

  getIndicadores() {
    this.listaVacia = true;
    this.loading = true;
    this._indicadores.getAllIndicadoresMarcasFacturas(this.buscador.getRawValue()).subscribe((res) => {
      console.log("getAllIndicadoresMarcasFacturas", res)
      this.loading = false;
      this.listaVacia = (res.length === 0) ? true : false;
      this.rowData = res;

      for (let index = 0; index < this.rowData.length; index++) {
        this.rowData[index].fecha_registro = this.rowData[index].fechaHoraSys.split('-').reverse().join('-');
      }
    }, (err) => {
      this.loading = false;
      this.listaVacia = true;
      this.rowData = [];
    });
  }

  listaDeAgencias;

  getAgencias() {
    this.loading = true;
    this._indicadores.getAgencias().subscribe((res: any) => {
      console.log("getAgencias()", res)
      this.loading = false;
      this.listaDeAgencias = res;
      this.listaDeAgencias.unshift(
        {
          "idOficinaVenta": "",
          "dscaOficinaVenta": "TODAS",
        }
      )

      for (let index = 0; index < this.listaDeAgencias.length; index++) {
        if (this.listaDeAgencias[index].idOficinaVenta == "")
          this.listaDeAgencias[index].dscaOficinaVenta = this.listaDeAgencias[index].dscaOficinaVenta;
        else
          this.listaDeAgencias[index].dscaOficinaVenta = this.listaDeAgencias[index].idOficinaVenta + " - " + this.listaDeAgencias[index].dscaOficinaVenta;
      }

    }, (err) => {
      this.loading = false;
      this.listaDeVersiones = '';
    });
  }


}
